import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import api from '../Api';
const ProtectedRoute = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
 
  const token = localStorage.getItem('token');
  
  useEffect(()=>{
    api.defaults.headers.common.Authorization =  token ? `Bearer ${token}` : '';
  },[token])

  let element = !isAuthenticated ? (
    <Navigate to="/login" />
  ) : (
    <Outlet />
  );

return element;
};

export default ProtectedRoute;
